import { ReactNode } from 'react';
import { useAuthProvider } from '@packages/provider/module/auth/auth-hook.ts';
import { AuthContext } from '@packages/provider/module/auth/auth-context.ts';

export const AuthProvider = ({ children }: { children: ReactNode }) => {
  const auth = useAuthProvider();
  return <AuthContext.Provider value={auth}>{children}</AuthContext.Provider>;
};
